import { ComponentExt } from '@src/utils/reactExt';
import { ListView, Icon, Modal } from 'antd-mobile';
import { observer, inject } from 'mobx-react';
import * as React from 'react'
import * as styles from './styles/index.scss'
import { deepClone, formatDate } from '@src/utils';
import intl from '@src/utils/intl';
@inject('suggestStoreG')
@observer
export default class Submission extends ComponentExt<any, any>{
    private store
    constructor(props) {
        super(props)
        this.store = props.suggestStoreG
        //初始化ListView
        const ds = new ListView.DataSource({
            rowHasChanged: (r1, r2) => r1 !== r2
        });
        this.state = {
            dataSource: ds,
            upLoading: false,
            pullLoading: false,
            showPrview: false,
            showPrviewImg: '',
            queryMyQuestion: []
        }
        this.store.getQueryMyQuestion()
    }
    componentWillUnmount() {
        this.store.clearMyquestion()
    }
    onClose = () => {
        this.setState({ showPrview: false })
    }
    //渲染数据每一项
    renderRow = (item, i) =>
        <div className={styles.questionValue}>
            <div className={styles.questionItem}>
                <p style={{ fontWeight: 500 }}>{item.questionDesc}</p>
                <div className={styles.imgItem}>
                    {item.image1.map(url =>
                        <img src={url} alt="" onClick={() => this.setState({ showPrview: true, showPrviewImg: url })} />
                    )}
                </div>
                <p className={styles.answerItem}>{`${formatDate(item.createDate)}UTC`}</p>
            </div>
            {item.answerList.length > 0 &&
                <div className={styles.questionItem}>
                    <p className={styles.reply}>LEN reply</p>
                    {item.answerList.map(answerItem =>
                        <div className={styles.replyItem}>
                            <p>{answerItem.answerDesc}</p>
                            <div className={styles.imgItem}>
                                {answerItem.image1.map(url1 =>
                                    <img src={url1} alt="" onClick={() => this.setState({ showPrview: true, showPrviewImg: url1 })} />
                                )}
                            </div>
                            <p className={styles.answerItem}>{`${formatDate(answerItem.createDate)}UTC`}</p>
                        </div>
                    )}
                </div>}
        </div>
    //上拉触底
    onEndReached = (val) => {
        if (this.store.queryMyQuestionList.length < this.store.total) {
            this.store.getQueryMyQuestion({ pageSize: this.store.pageSize + 1, current: 10 })
        }
    }
    render() {
        const { dataSource } = this.state
        const queryMyQuestionList = deepClone(this.store.queryMyQuestionList) || []
        return <div style={{ height: '100%' }}>
            <header className={styles.title}>{intl.formatMessage({ id: "suggest.title" })}</header>
            <Modal
                visible={this.state.showPrview}
                transparent
                maskClosable={false}
                closable
                onClose={this.onClose}
                style={{ overflow: 'auto' }}
            >
                <img className={styles.prviewImg} src={this.state.showPrviewImg} />
            </Modal>
            <div className={styles.questionWrapper}>
                {queryMyQuestionList.length > 0 ?
                    <ListView
                        dataSource={dataSource.cloneWithRows(queryMyQuestionList)}
                        renderRow={(rowData, id1, i) => this.renderRow(rowData, i)}
                        initialListSize={10}
                        pageSize={10}
                        style={{ height: '100%' }}
                        renderFooter={() => (<div style={{ padding: 30, textAlign: 'center' }}>
                            {(queryMyQuestionList.length < this.store.total) ? <Icon type="loading" /> : intl.formatMessage({ id: 'suggest.noMore' })}
                        </div>)}
                        onEndReached={(e) => this.onEndReached(e)}
                        onEndReachedThreshold={20}
                    >
                    </ListView> : <div style={{ padding: 30, textAlign: 'center' }}>
                        {intl.formatMessage({ id: 'suggest.noMore' })}
                    </div>}
            </div>
        </div >
    }
}